import React, { useEffect, useState } from "react";
import { Button, Divider } from "antd";
import SelectValueFilter from "./SelectValueFilter";
import FilterCondition from "./ConditionFilter";

const FilterPopover = ({
  columnKey,
  options = [],
  selected = [],
  onApply,
  onClear,
  onClose,
  setSort,
  type,
  resetFilterColumn = () => {},
  allOptions=[]
}) => {
  const allSelect = allOptions.map((i) => i.value);
  const [checkedList, setCheckedList] = useState(selected);
  const [searchTerm, setSearchTerm] = useState("");
  const [originSearch,setOriginSearch] = useState("")
  const [tab, setTab] = useState("0");
  const [conditionObj, setConditionObj] = useState({
    condition1: "0",
    condition2: "0",
    operator: "AND",
    conditionValue1: "",
    conditionValue2: "",
  });
  useEffect(() => {
    setCheckedList(selected);
  }, [selected]);
  useEffect(() => {
    setSearchTerm("");
    resetCondition()
  }, [JSON.stringify(options)]);
  let filteredOptions = options.map((opt) => ({
    ...opt,
    label: String(opt.label),
  }));
  filteredOptions = filteredOptions.filter(
    (opt) =>
      typeof opt.label === "string" &&
      opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const setSortAsc = (mode) => {
    setSort({
      mode,
      key: columnKey,
      type: type || "string",
    });
    onClose();
  };

  const resetCondition = () => {
    setConditionObj({
      condition1: "0",
      condition2: "0",
      operator: "AND",
      conditionValue1: "",
      conditionValue2: "",
    });
  };
  function matchStringCondition(text, operator, value) {
    text = String(text || "").trim();
    value = String(value || "").trim();

    switch (operator) {
      case "0": // No condition (always pass)
        return true;
      case "1": // Equals
        return text === value;
      case "2": // Not equals
        return text !== value;
      case "3": // Starts with
        return text.startsWith(value);
      case "4": // Ends with
        return text.endsWith(value);
      case "5": // Contains
        return text.includes(value);
      case "6": // Does not contain
        return !text.includes(value);
      default:
        return false; // Invalid operator
    }
  }
  function matchNumberCondition(target, operator, value) {
    const numTarget = Number(target);
    const numValue = Number(value);

    // If either value is NaN, consider it invalid
    if (isNaN(numTarget) || isNaN(numValue)) return false;

    switch (operator) {
      case "0": // No condition
        return true;
      case "1": // Equals
        return numTarget === numValue;
      case "2": // Not equals
        return numTarget !== numValue;
      case "3": // Greater than
        return numTarget > numValue;
      case "4": // Greater than or equal
        return numTarget >= numValue;
      case "5": // Less than
        return numTarget < numValue;
      case "6": // Less than or equal
        return numTarget <= numValue;
      default:
        return false; // Invalid operator
    }
  }
  // ACTION
  const handleSave = () => {
    if (tab == 0) {
      const filnalOptionValue = filteredOptions.map((i) => i.value);
      const finalChecked = checkedList.filter((i) =>
        filnalOptionValue.includes(i)
      );
      setOriginSearch(searchTerm)
      onApply(columnKey, finalChecked);
      resetCondition();
    } else {
      const listConditionSelect = allSelect.filter((value) => {
        let con1, con2;
        if (type === "number") {
          con1 = matchNumberCondition(
            value,
            conditionObj.condition1,
            conditionObj.conditionValue1
          );
          con2 = matchNumberCondition(
            value,
            conditionObj.condition2,
            conditionObj.conditionValue2
          );
        } else {
          con1 = matchStringCondition(
            value,
            conditionObj.condition1,
            conditionObj.conditionValue1
          );
          con2 = matchStringCondition(
            value,
            conditionObj.condition2,
            conditionObj.conditionValue2
          );
        }
        return conditionObj.operator === "AND" ? con1 && con2 : con1 || con2;
      });
      setCheckedList(listConditionSelect);
      onApply(columnKey, listConditionSelect);
      setSearchTerm("")
      onClose();
    }
    onClose();
  };
  const handleCancel = () => {
    setCheckedList(selected);
    setTab("0");
    onClose();
    setSearchTerm(originSearch)
    filteredOptions = filteredOptions.filter(
      (opt) =>
        typeof opt.label === "string" &&
        opt.label.toLowerCase().includes(originSearch.toLowerCase())
    );
  };
  const handleReset = () => {
    setCheckedList(allSelect);
    resetCondition();
    onApply(columnKey, allSelect,"",true);
    onClose();
    resetFilterColumn(columnKey)
    setSearchTerm("")
    setOriginSearch("")
  };
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{ width: 250, padding: 10 }}
    >
      <div
        className="mb10"
        style={{ display: "flex", justifyContent: "space-between", gap: 10 }}
      >
        <Button
          className="buttonSortColumn"
          size="small"
          onClick={() => setSortAsc("asc")}
        >
          ↑昇順
        </Button>
        <Button
          className="buttonSortColumn"
          size="small"
          onClick={() => setSortAsc("desc")}
        >
          ↓降順
        </Button>
      </div>
      <div className="wrap-tab-select-filter">
        <span
          onClick={() => setTab("1")}
          className={`option-filter ${tab == 1 && "option-filter-active"}`}
        >
          条件フィルタ
        </span>
        <span
          onClick={() => setTab("0")}
          className={`option-filter ${tab == 0 && "option-filter-active"}`}
        >
          値フィルタ
        </span>
      </div>

      {tab == 0 ? (
        <SelectValueFilter
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filteredOptions={filteredOptions}
          checkedList={checkedList}
          setCheckedList={setCheckedList}
        />
      ) : (
        <FilterCondition
          conditionObj={conditionObj}
          setConditionObj={setConditionObj}
          type={type}
        />
      )}

      <Divider style={{ margin: "12px 0" }} />

      <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
        <Button
          style={{ flex: 1, letterSpacing: -1.5 }}
          type="primary"
          size="small"
          onClick={() => {
            handleSave();
          }}
        >
          適用
        </Button>
        <Button
          id={`cancel-filter-table-${columnKey}`}
          style={{ flex: 1 }}
          size="small"
          onClick={() => {
            handleCancel();
          }}
        >
          キャンセル
        </Button>
        <Button
          style={{ flex: 1 }}
          size="small"
          onClick={() => {
            handleReset();
          }}
        >
          クリア
        </Button>
      </div>
    </div>
  );
};

export default FilterPopover;
